import { render, staticRenderFns } from "./Poetry.vue?vue&type=template&id=d6d65132"
import script from "./Poetry.vue?vue&type=script&lang=js"
export * from "./Poetry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports